import { render, staticRenderFns } from "./RefundList.vue?vue&type=template&id=8a51383c&scoped=true"
import script from "./RefundList.vue?vue&type=script&lang=js"
export * from "./RefundList.vue?vue&type=script&lang=js"
import style0 from "./RefundList.vue?vue&type=style&index=0&id=8a51383c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a51383c",
  null
  
)

export default component.exports